import Encryption from "./Encryption";

function EncryptInput(data, formData) {
  let cardInfo = {
    cardNumber: "",
    year: "",
    month: "",
    cvv: "",
    cardHolderName: "",
    brand: "",
    typeOfCard : ""
  };
  if (formData.modeOfPayment === "CARD") {
    cardInfo = formData;
  }
  const enc_data = {salt: "", delimiter: "", cardRefNumber: ""};
  const seperator = Math.random().toString(36).substring(2, 12);
  let randomString = data?.transactionID + seperator + data?.token + seperator + data?.totalAmount + seperator + data?.tid;
  enc_data.salt = Encryption(randomString, data?.datakey, data?.pg);
  if (data?.pg === 10) {
    enc_data.delimiter = seperator
  } else {
    enc_data.delimiter = Encryption(seperator, data?.datakey, data?.pg);
  }


  let carddetails =
      cardInfo.cardNumber +
      seperator +
      cardInfo?.year +
      cardInfo?.month +
      seperator +
      cardInfo?.cvv +
      seperator +
      cardInfo?.cardHolderName +
      seperator +
      cardInfo?.brand +
      seperator +
      randomString + 
      seperator + 
      cardInfo.typeOfCard; //currrently not applicable once dc and cc identified.we need to pass respectivr value.
  enc_data.cardRefNumber = Encryption(carddetails, data?.datakey, data?.pg);
  return enc_data;
}

export default EncryptInput;
